import React from 'react'
import Flex from 'components/Flex'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import QuickShopProductSidebarColorSwatchesItem from 'containers/QuickShopProductSidebar/components/ColorSwatches/components/Item'
import updateSelectedColorOptionAction from 'modules/variant/redux/actions/update-selected-color-option'
import updateShouldUpdateMediaAction from 'modules/media-gallery/redux/actions/update-should-update-media'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import useDispatch from 'hooks/use-dispatch'
import logUtil from 'utils/log'

/**
 * @param {Object} props
 * @param {ProductVariantCollection[]} props.allVariants
 * @param {ProductVariantCollection[]} props.otherVariants
 * @param {ProductVariantCollection} props.selectedVariant
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarColorSwatchesList (props) {
  const dispatch = useDispatch()

  const {
    allVariants,
    selectedVariant,
    otherVariants
  } = props

  logUtil('QuickShopProductSidebarColorSwatchesList').debug('props=', props)

  const handleClickVariant = async (variant) => {
    /**
     * update the selected color index
     */

    dispatch(
      updateShouldUpdateMediaAction(false)
    )

    dispatch(
      updateSelectedColorOptionAction({
        selectedOption: variant?.color_option ?? variant?.option_value
      })
    )

    /**
     * If user press this then stop other media gallery from updating
     */
    const variantId = variant.variant_id
    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId,
        shouldAddToUrl: false,
        fromSidebar: true,
        updateMediaGallery: true,
        caller: 'QuickShopProductSidebarColorSwatchesList'
      })
    )

    /**
     * if quick shop opens up and user immediately clicks on the color swatches we want that selection
     * to have priority over the media gallery selection by other utils, so we will make shouldUpdateMediaGallery
     * false and then after a delay we will set it to true
     */

    await runAfterDelayTimingUtil(1500)
    dispatch(
      updateShouldUpdateMediaAction(true)
    )
  }

  return (
    <Flex className='quick-shop-product-sidebar-color-swatches-list'>
      {
        allVariants.map((variant, index) => {
          const isOtherVariant = otherVariants.some((otherVariant) => {
            return otherVariant.variant_id === variant.variant_id
          })

          if (isOtherVariant) {
            return null
          }

          const isSelected = variant?.variant_id === selectedVariant?.variant_id
          return (
            <QuickShopProductSidebarColorSwatchesItem
              productVariant={variant}
              key={`${variant.product_id}-${variant.variant_id}-${index}`}
              isSelected={isSelected}
              onClick={handleClickVariant}
            />
          )
        })
      }
    </Flex>
  )
}
